import React from "react"
import { connect } from "react-redux"
import ExpenseForm from "./ExpenseForm"
import { startAddExpense, startEditExpense, startRemoveExpense } from "../actions/expenses"

export class CopyExpensePage extends React.Component {
  onSubmit = (expense) => {
    this.props.startAddExpense(expense)
    this.props.history.push("/")
  }

  onAddNew = (expense) => {
    this.props.startAddExpense(expense)
    this.props.history.push("/")
  }

  onRemove = () => {
    this.props.startRemoveExpense({ id: this.props.expense.id })
    this.props.history.push("/")
  }
  render() {
    return (
      <div>
        <div className="page-header">
          <div className="content-container">
            <h1 className="page-header__title">Add Expense</h1>
          </div>
        </div>
        <div className="content-container">
          <ExpenseForm expense={this.props.expense} labels={this.props.labels} onSubmit={this.onSubmit} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  expense: state.expenses.find((expense) => expense.id === props.match.params.id),
  labels: state.labels,
})

const mapDispatchToProps = (dispatch, props) => ({
  startEditExpense: (id, expense) => dispatch(startEditExpense(id, expense)),
  startRemoveExpense: (data) => dispatch(startRemoveExpense(data)),
  startAddExpense: (expense) => dispatch(startAddExpense(expense)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CopyExpensePage)



// WEBPACK FOOTER //
// ./src/components/CopyExpensePage.js